<div class="view-button" *ngIf="isGridView" [ngClass]="{ active: isGridView }"
                         (click)="setList()">
  <i class="fa fa-list"></i>
</div>
<div class="view-button" *ngIf="isListView" [ngClass]="{ active: isListView }"
                         (click)="setGrid()">
  <i class="fa fa-th"></i>
</div>
<!--
  SK: switched off for now - added container site for bigger screens 

<span class="divider"></span>
<div class="view-button"
     [ngClass]="{'toggle': fullWidthView$ | async}"
     (click)="toggleFullWidthView()">
  <i class="fa fa-external-link-square"></i>
</div>
-->